module.exports = __webpack_public_path__ + "img/showcase-hero-thumb.76d6f0a0.png";